import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { BuilderContextProvidersSiteConfig, ContextProviderRegistry } from './types'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'

export const BuilderContextProvidersRegistry = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteFeatureConfig: BuilderContextProvidersSiteConfig): ContextProviderRegistry => {
		const registry: { [contextType: string]: any } = {}
		return {
			registerContextProvider: (contextType: string, contextProviderModule: any) => {
				registry[contextType] = contextProviderModule
			},
			has(contextType: string) {
				return Boolean(registry[contextType])
			},
			getContextProvider: (contextType: string) => {
				if (!registry[contextType]) {
					console.warn(
						`Context provider "${contextType}" is not registered, make sure to load it first with builderContextProvidersLoader.retrieveContextProviders().`
					)
				}
				return registry[contextType]
			},
			getUseContextHook: (contextType: string) => {
				const contextConfig = siteFeatureConfig.contextProviders[contextType]
				if (!contextConfig) {
					console.warn(
						`Context provider "${contextType}" is not configured. ` +
							`Available providers: [${Object.keys(siteFeatureConfig.contextProviders).join(', ')}]`
					)
					return
				}

				const hookAccessor = contextConfig.contextSpecifier?.hook
				if (!hookAccessor) {
					console.warn(`Context provider "${contextType}" is missing contextSpecifier.hook configuration`)
					return
				}

				const module = registry[contextType]
				if (!module) {
					console.warn(
						`Context provider "${contextType}" module is not loaded. ` +
							`Did retrieveContextProviders() complete before rendering?`
					)
					return
				}

				const hook = module[hookAccessor]
				if (typeof hook !== 'function') {
					console.warn(
						`Context provider "${contextType}" module does not export hook "${hookAccessor}". ` +
							`Available exports: [${Object.keys(module).join(', ')}]`
					)
					return
				}

				return hook
			},
		}
	}
)
